import {
  ApiCartChangeCartDeliveryModeRequestedAction,
  apiCartChangeCartDeliveryModeFailed,
  apiCartChangeCartDeliveryModeSucceeded
} from '../../../api/cart/changeCartDeliveryModeApi';
import { call, put } from 'typed-redux-saga';
import changeCartDeliveryModeAction, {
  ChangeCartDeliveryModeActionInput,
  ChangeCartDeliveryModeActionResult
} from '@spa/lib/actions/cart/changeCartDeliveryModeAction';

function* changeCartDeliveryModeSaga({
  payload: { actionId: requestedActionId, customOrderType, parentActionId }
}: ApiCartChangeCartDeliveryModeRequestedAction): Generator {
  try {
    const input: ChangeCartDeliveryModeActionInput = { customOrderType };
    const { cartId, result }: ChangeCartDeliveryModeActionResult = yield* call(
      changeCartDeliveryModeAction,
      'changeCartDeliveryModeAction',
      input
    );
    yield* put(
      apiCartChangeCartDeliveryModeSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartDeliveryModeFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartDeliveryModeSaga;
